import type { FaireProductEntity } from "../../entity_types/product";

export const ai_bulk_3: FaireProductEntity = {
  token: "ai_bulk_3",
  type: "product",
  name: "Ramen Puzzle",
  brandName: "Ai Bulk Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1b6cac351a793c35766f251ea909eb9766b88f7285b9499e21b7638e48cc3f6c.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 37.25,
  msrpDollars: 74.5,
  description: "",
  tags: ["women-owned"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
